module.exports = __webpack_public_path__ + "static/media/service-list-mobile@2x.d7765a76.jpg";